'use client'

import { useEffect } from 'react'
import { clearSupabaseAuthCookies } from '@amtil/database'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const isAuthError =
    error.message?.includes('UTF-8') || error.message?.includes('auth')

  useEffect(() => {
    console.error('[Connect] Unhandled error:', error)
    // Auto-clear corrupt cookies for auth errors
    if (isAuthError) {
      clearSupabaseAuthCookies()
    }
  }, [error, isAuthError])

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--surface-bg)] p-4">
      <div className="max-w-md text-center">
        <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-2">
          {isAuthError ? 'Session Error' : 'Something went wrong'}
        </h2>
        <p className="text-sm text-[var(--text-muted)] mb-6">
          {isAuthError
            ? 'Your session data was corrupted. This has been automatically fixed.'
            : 'An unexpected error occurred.'}
        </p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={reset}
            className="px-4 py-2 bg-[var(--primary)] text-white rounded-lg text-sm font-medium hover:opacity-90 transition-opacity"
          >
            Try Again
          </button>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-[var(--surface-muted)] text-[var(--text-primary)] rounded-lg text-sm font-medium hover:bg-[var(--surface-card)] transition-colors"
          >
            Reload Page
          </button>
        </div>
      </div>
    </div>
  )
}
